module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Aquarium-f54f9e97b36c6194c5e4b29a4b7d0f70.png";